'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import { ACADEMY_IFRAME_INITIATED } from '../../../LearningCenter';

const PracticalExerciseAcademyModal = ({
  open,
  setOpen
}) => {
  const closeModal = useCallback(() => setOpen(false), [setOpen]);
  useEffect(() => {
    const handleIframeMessage = event => {
      if (event.origin !== window.location.origin) return;

      if (event.data === ACADEMY_IFRAME_INITIATED || event.message === ACADEMY_IFRAME_INITIATED) {
        setOpen(true);
      }
    };

    window.addEventListener('message', handleIframeMessage, false);
    return () => {
      window.removeEventListener('scroll', handleIframeMessage);
    };
  }, [setOpen]);
  if (!open) return null;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: "Academy inception"
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: "You've opened HubpSpot Academy inside HubpSpot Academy. Do you want to go back to the start of the exercise? Or back to the course maybe?"
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        children: "Back to course"
      }), /*#__PURE__*/_jsx(UIButton, {
        children: "Back to exercise"
      })]
    })]
  });
};

PracticalExerciseAcademyModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func
};
export default PracticalExerciseAcademyModal;